module.exports = __webpack_public_path__ + "./Katherine_pbw_30e570542ec3999727ee015eaffe645d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Katherine_pbw.png
// module id = 595
// module chunks = 0